import { useState } from "react";
import { useSnackbar } from 'notistack';
import { Paper, Grid, } from "@mui/material";
import { getPortfolioReportApi } from "../apiService";
import { globalPostService } from "../../../utils/globalApiServices";
import { checkApiStatus } from "../../../utils";
import { ExportMenu, PageLoader } from "../../../shared_elements";
import LessorFilter from "./LessorFilter";
import Header from "./Header";

const PortfolioReport = ({pltConstants,dropDownLoader}) => {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setLoading] = useState(false)
  const [reportData, setReportData] = useState({});
  const onFieldChange = (key, value) => { setReportData({ ...reportData, [key]: value }) }

  const onExportReport = (extention) => {
      const getIdArray = (arr) => arr?.length ? arr.map((i) => i.id) : undefined;
      const lessorIds = getIdArray(reportData?.lessor_name_id);
      const payload = {
        file_type: extention,
        ...(lessorIds && { lessor_name_ids: lessorIds })
      };
      setLoading(true)
      globalPostService(getPortfolioReportApi(), payload)
        .then(response => {
          setLoading(false)
          if (checkApiStatus(response)) {
            setReportData({})
            enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" }, })
          } else {
            enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" }, })
          }
        });
  };
  return (
    <Paper square>
      <div className='custom-rpt-card'>
        <div className='rpt-card-header'>
          <Grid container spacing={{ xs: 5, md: 1 }}>
            <Grid size={{ md: 10, xs: 8 }}>
              <Header title="Portfolio Report" description="This report will capture the Portfolio Information." />
            </Grid>
            <Grid size={{ md: 2, xs: 4 }} sx={{ display: "flex", justifyContent: "flex-end",alignItems: "center" }}>
              <ExportMenu
                exportReportFn={(file) => onExportReport(file.extension)}
                files={[{ title: 'EXCEL', extension: 'xlsx' }]}
              />
            </Grid>
          </Grid>
        </div>
        <Grid sx={{ padding: 2 }} container spacing={1}>
          <Grid size={{ md: 12, xs: 12 }}>
           <LessorFilter pltConstants={pltConstants} dropDownLoader={dropDownLoader} reportData={reportData} onFieldChange={onFieldChange}/>
          </Grid>
        </Grid>
      </div>
      {isLoading ? <PageLoader /> : null}
    </Paper>
  )
}

export default PortfolioReport